<img [class]="class" loading="lazy" [src]="src" [alt]="alt" [attr.width]="width" [attr.height]="height">